<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">Contato do Cliente</div>
            </div>
            <hr style="margin-top: -4px" />
            <div class="col-md-12">
              <form action>
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label for="Name">
                      <span class="required">*</span> Nome:
                    </label>
                    <input
                      autocomplete="new-password"
                      type="text"
                      id="Name"
                      class="form-control"
                      v-model="client_contact.name"
                      placeholder=""
                    />
                  </div>
                  <div class="form-group col-md-6">
                    <label for="Email">
                      <span class="required">*</span> Email:
                    </label>
                    <input
                      autocomplete="new-password"
                      class="form-control"
                      id="Email"
                      placeholder=""
                      type="email"
                      v-model="client_contact.email"
                    />
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-4">
                    <label for="Cellphone">Celular:</label>
                    <input
                      autocomplete="new-password"
                      class="form-control"
                      type="text"
                      v-model="client_contact.cellphone"
                      v-mask="'(99) 99999-9999'"
                    />
                  </div>
                  <div class="form-group col-md-4">
                    <label for="Cellphone">Cliente:</label>
                    <v-select
                      v-model="client_contact.client_id"
                      :options="clients"
                      :reduce="(clients) => clients.id"
                      :label="'company_name'"
                    ></v-select>
                  </div>
                  <div class="form-group col-md-4">
                    <label for="inputUser">
                      <span class="required">*</span> Status:
                    </label>
                    <select
                      v-model="client_contact.status"
                      class="form-control"
                    >
                      <option :value="1">Ativo</option>
                      <option :value="0">Inativo</option>
                    </select>
                  </div>
                </div>
                <span class="required_fields">
                  <span class="required">*</span>
                  <strong>Campos obrigatórios</strong>
                </span>
                <div class="block text-right mb-1">
                  <router-link to="/client_contacts" class="btn btn-back">
                    <i class="fa fa-arrow-left"></i> Voltar
                  </router-link>
                  <a class="btn btn-add ml-1" @click="save">
                    Salvar
                    <i class="fa fa-save"></i>
                  </a>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";

export default {
  name: "imageUpload",
  data() {
    return {
      client_contact: {
        company_name: "",
        cellphone: "",
        email: "",
        status: "",
      },
      clients: [],
    };
  },
  computed: {},
  methods: {
    save: function () {
      const self = this;
      let api = self.$store.state.api + "client_contacts";

      if (self.client_contact.id) {
        api += "/" + self.client_contact.id;
        self.client_contact._method = "PUT";
      }

      axios
        .post(api, self.client_contact)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/client_contacts");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getClientContact: function (id) {
      const self = this;
      const api = self.$store.state.api + "client_contacts/" + id;

      axios
        .get(api)
        .then((response) => {
          self.client_contact = response.data.data[0];
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getClients: function () {
      const self = this;
      const api = self.$store.state.api + "clients/";

      axios
        .get(api)
        .then((response) => {
          self.clients = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;
    let id = self.$route.params.id;

    self.getClients();

    if (id) {
      self.getClientContact(id);
    }
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}

.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>